import React, { useState, useEffect } from 'react';
import './AttendanceDetail.css';
import { FaUser } from "react-icons/fa";
import { GrNotification } from "react-icons/gr";
import config from '../../config'; // Adjust this path to your config file
import { IoIosArrowBack } from "react-icons/io";
import Header from "../../components/common/Header";

const AttendanceDetail = ({ attendance, onClose }) => {
  // 1. Initialize month from the clicked row's date or current month
  const initialMonth = attendance.date ? attendance.date.substring(0, 7) : new Date().toISOString().substring(0, 7);
  const [selectedMonth, setSelectedMonth] = useState(initialMonth);
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [summaryData, setSummaryData] = useState(null);

  const getMonthName = (monthNumber) => {
  const months = [
    "JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE",
    "JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER"
  ];
  return months[monthNumber - 1];
};
  // 2. Function to fetch data from API
  const fetchAttendanceDetail = async (monthStr) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('Authorization');
      const orgId = localStorage.getItem('orgId') || '6';
      
      // Split "YYYY-MM"
      const [year, month] = monthStr.split('-');
      
      // Use employeeCode from the clicked row (attendance object)
      const employeeCode = attendance.employeeCode || attendance.employeeKey || 'EMP-201';
      const clientId = attendance.clientKey || '51';

      const url = `${config.API_BASE_URL}${config.ATTENDANCE_DETAIL_ENDPOINT}?orgId=${orgId}&clientId=${clientId}&employeeCode=${employeeCode}&month=${parseInt(month)}&year=${year}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Failed to fetch details');

      const result = await response.json();
      // Update state with API body
      setDetailData(result.body);
    } catch (error) {
      console.error("Error fetching attendance details:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAttendanceSummary = async (monthStr) => {
  try {

    const token = localStorage.getItem("Authorization");
    const orgKey = localStorage.getItem("orgId") || "32";

    const [year, month] = monthStr.split("-");
    const monthName = getMonthName(parseInt(month));

    const employeeCode = attendance.employeeCode || "EMP-181";
    const clientKey = attendance.clientKey || "51";

    const url = `${config.API_BASE_URL}${config.ATTENDANCE_SUMMARY_ENDPOINT}?orgKey=${orgKey}&clientKey=${clientKey}&employeeCode=${employeeCode}&month=${monthName}&year=${year}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });

    const result = await response.json();

    setSummaryData(result.body);

  } catch (error) {
    console.error("Summary API error:", error);
  }
};

  // 3. Fetch data on component mount and when month changes
 useEffect(() => {
  fetchAttendanceDetail(selectedMonth);
  fetchAttendanceSummary(selectedMonth);
}, [selectedMonth, attendance]);

  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  return (
    <div className="attendance-detail-container">
      <Header 
        title="Employee Attendance" 
        subtitle="Employee Attendance information" 
        showBack={true} 
        onBack={onClose} 
      />

      <div className="attendance-detail-content">
        <div className="detail-actions">
          <button className="back-button" onClick={onClose}>
            ← Back
          </button>
        </div>

        <div className="detail-card">
          {loading && !detailData ? (
            <div className="detail-loading-container">
              <div className="spinner"></div>
              <p>Loading attendance details...</p>
            </div>
          ) : (
            <>
              <div className="detail-section">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px',marginTop: '-10px' }}>
                  <h3 className="section-title">
                    <FaUser className="icon" />
                    Employee Attendance
                  </h3>
                </div>

                <div className="detail-grid">
                  <div className="detail-item">
                    <label>Employee Name</label>
                    <input type="text" value={detailData?.employeeName || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Employee Key</label>
                    <input type="text" value={detailData?.employeeKey || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Client Employee ID</label>
                    {/* Unga JSON la 'employeeId' nu iruku */}
                    <input type="text" value={detailData?.employeeId || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Mobile Number</label>
                    <input type="text" value={detailData?.mobileNumber || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Client Name</label>
                    <input type="text" value={detailData?.clientName || 'N/A'} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Job Role</label>
                    <input type="text" value={detailData?.jobRole || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Work Site</label>
                    <input type="text" value={detailData?.workSite || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Employee Status</label>
                    {/* JSON key 'status' nu iruku */}
                    <input type="text" value={detailData?.status || 'Active'} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Aadhar</label>
                    {/* JSON key 'aadharNumber' nu iruku */}
                    <input type="text" value={detailData?.aadharNumber || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>UAN</label>
                    {/* JSON key 'uanNumber' nu iruku */}
                    <input type="text" value={detailData?.uanNumber || ''} readOnly />
                  </div>
                  <div className="detail-item">
                    <label>Date Of Joining</label>
                    {/* JSON key 'dateOfJoin' nu iruku */}
                    <input type="text" value={detailData?.dateOfJoin || ''} readOnly />
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <div className="section-header" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <h3 className="section-title">
                    <FaUser className="icon" />
                    Overall Attendance
                  </h3>

                  <div className="attendance-month-selector">
                    <label>Attendance Month</label>
                    <input 
                      type="month" 
                      value={selectedMonth} 
                      onChange={handleMonthChange}
                      className="month-input" 
                    />
                  </div>
                </div>

                <div className="attendance-stats">
                  <div className="stat-item">
                    <label>Total days in the month</label>
                    <div className="stat-value">{summaryData?.totalDays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>No.of present days</label>
                    <div className="stat-value">{summaryData?.presentDays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>N&P Holidays</label>
                    <div className="stat-value">{summaryData?.nrpHolidays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>LOP Days</label>
                    <div className="stat-value">{summaryData?.lopDays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>Week Off days</label>
                    <div className="stat-value">{summaryData?.weekOffDays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>Total Pay Days</label>
                    <div className="stat-value">{summaryData?.totalPayDays || 0}</div>
                  </div>

                  <div className="stat-item">
                    <label>OT Hours</label>
                    <div className="stat-value">{summaryData?.otHours || 0}</div>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <table className="attendance-table">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Check In</th>
                      <th>Check Out</th>
                      <th>Shift Name</th>
                      <th>Work Hours</th>
                      <th>OT Hours</th>
                      <th>Pay day</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailData?.dailyAttendance?.map((day, index) => (
                      <tr key={index}>
                        <td>{day.date}</td>
                        <td>{day.checkIn}</td>
                        <td>{day.checkOut}</td>
                        <td>{day.shiftName}</td>
                        <td>{day.workHours}</td>
                        <td>{day.otHours}</td>
                        <td>{day.payDay}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceDetail;